import { makeStyles, Theme } from "@material-ui/core"

export default makeStyles((theme: Theme) => ({
  root: (props: { dense: boolean }) => ({
    border: 0,
    padding: 0,
    marginTop: theme.spacing(props.dense ? 0 : 3),
  }),
}))
